import dayjs, { Dayjs } from 'dayjs';

export const getSafeISOString = (date?: string | Date | Dayjs) => {
  if (!date) {
    return dayjs().toISOString();
  }

  try {
    return dayjs(date).toISOString();
  } catch (e) {
    return dayjs().toISOString();
  }
};
